import snakecaseKeys from "snakecase-keys";

import {
  deleteNotice,
  getDisplayNotices,
  getNoticePage,
  onCreateNotice,
  updateNotice,
} from "../../services/apis/notice";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

// Sign Up
export const doCreateNotice = createAsyncThunk(
  "notice/doCreateNotice",
  async params => {
    const result = await onCreateNotice(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doUpdateNotice = createAsyncThunk(
  "notice/doUpdateNotice",
  async params => {
    const request = snakecaseKeys(params);
    const id = params.id;
    const result = await updateNotice(id, request);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doDeleteNotice = createAsyncThunk(
  "notice/doDeleteNotice",
  async id => {
    const result = await deleteNotice(id);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doGetNoticePage = createAsyncThunk(
  "notice/doGetNoticePage",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k]
                .trim()
                .replaceAll(/&/g, "&amp;")
                .replaceAll(/>/g, "&gt;")
                .replaceAll(/</g, "&lt;")
                .replaceAll(/"/g, '"')
                .replaceAll(/\\/g, "\\\\")
            : request[k])
    );
    const result = await getNoticePage(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return result;
  }
);

export const doGetNoticeDisplay = createAsyncThunk(
  "notice/doDisplayNotices",
  async () => {
    const result = await getDisplayNotices();
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  isSaving: false,
  list: [],
};

const slice = createSlice({
  name: "notice",
  initialState: initialState,
  reducers: {
    setNumberOfElements: (state, action) => {
      state.numberOfElements = action.payload;
    },
    resetNotice: state => {
      state.list = [];
    },
  },
  extraReducers: {
    [doCreateNotice.pending]: state => {
      state.isSaving = true;
    },
    [doCreateNotice.fulfilled]: state => {
      state.isSaving = false;
    },
    [doCreateNotice.rejected]: state => {
      state.isSaving = false;
    },
    [doUpdateNotice.pending]: state => {
      state.isSaving = true;
    },
    [doUpdateNotice.fulfilled]: state => {
      state.isSaving = false;
    },
    [doUpdateNotice.rejected]: state => {
      state.isSaving = false;
    },
    [doDeleteNotice.pending]: state => {
      state.isSaving = true;
    },
    [doDeleteNotice.fulfilled]: state => {
      state.isSaving = false;
    },
    [doDeleteNotice.rejected]: state => {
      state.isSaving = false;
    },
    [doGetNoticeDisplay.pending]: state => {
      state.list = [];
      return state;
    },
    [doGetNoticeDisplay.fulfilled]: (state, action) => {
      const { payload } = action;
      if (payload) {
        state.list = payload;
      }
      return state;
    },
    [doGetNoticeDisplay.rejected]: state => {
      state.list = [];
      return state;
    },
  },
});

const { reducer, actions } = slice;
export const { setNumberOfElements, resetNotice } = actions;

export default reducer;

export const isSaving = createSelector(
  state => state.notice.isSaving,
  isSaving => isSaving
);

export const numOfEls = createSelector(
  state => state.notice.numberOfElements,
  numberOfElements => numberOfElements
);

export const fecthNoticeDisplay = createSelector(
  state => state.notice.list,
  list => list
);
